import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "./FeaturedCategoryCard.css";

export default function FeaturedCategoryCard({ icon, label, teaser, services = [], ctaHref, ctaLabel }) {
  return (
    <div className="featured-category-card">
      <div className="fcc-head">
        <span className="fcc-icon" aria-hidden="true">{icon}</span>
        <h3 className="fcc-label">{label}</h3>
      </div>
      {teaser && <p className="fcc-teaser">{teaser}</p>}
      {services.length > 0 && (
        <ul className="fcc-services">
          {services.map((s) => (
            <li key={s.slug}>
              <Link to={s.href}>{s.name}</Link>
            </li>
          ))}
        </ul>
      )}
      <Link to={ctaHref} className="fcc-cta">
        {ctaLabel || `View all ${label}`} <FaArrowRight aria-hidden="true" />
      </Link>
    </div>
  );
}
